import { PaymentMapper } from "@/domain/mappers";
import { CreditCardResponse } from "../dtos/responses";
import { CreditCard } from "@/domain/entities";

export class PaymentMapperImpl implements PaymentMapper<CreditCardResponse> {
  toCreditCardDomain(data: CreditCardResponse): CreditCard {
    return {
      card_id: data.id,
      last_digits: data.card.last4,
    };
  }
}
